/**
 * Google Tag Manager dataLayer helper.
 *
 * GTM is intentionally restricted to the live customer domain so that
 * preview / staging / local-dev traffic never pollutes production
 * analytics dashboards or fires production-side Pixel/GA/Ads tags by
 * accident.
 *
 * Allow-listed hostnames (must match exactly — sub-domain checks would
 * accidentally include preview environments):
 *   - astroconsult.app
 *   - www.astroconsult.app
 *
 * The script-side gate lives in `public/index.html`; this helper covers
 * every dataLayer.push call site (signup, purchase, future events).
 */
const PRODUCTION_HOSTS = new Set(['astroconsult.app', 'www.astroconsult.app']);

export function isProductionHost() {
    if (typeof window === 'undefined') return false;
    return PRODUCTION_HOSTS.has(window.location.hostname);
}

export function gtmPush(payload) {
    if (!isProductionHost()) return;
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    } catch {
        /* analytics must never break the user flow */
    }
}
